// Shared with the landing site (www.mountmonitor.com). Do not change these
// without Marketing.
export const GA4_MEASUREMENT_ID = "G-DXVJ67R8KM";
export const GOOGLE_ADS_ID = "AW-712137915";

export const MARKETING_LINKER_DOMAINS = [
  "mountmonitor.com",
  "www.mountmonitor.com",
  "app.mountmonitor.com",
] as const;

export const MARKETING_EVENTS = {
  accountCreated: "account_created",
  stripeVerified: "stripe_verified",
} as const;

export type MarketingEventName =
  (typeof MARKETING_EVENTS)[keyof typeof MARKETING_EVENTS];

// Google Ads conversion send_to labels from Marketing (Morgan). Used as
// gtag('event', 'conversion', { send_to }). Do not use page_view as an Ads
// conversion.
export const GOOGLE_ADS_CONVERSION_SEND_TO: Record<MarketingEventName, string> =
  {
    [MARKETING_EVENTS.accountCreated]: "AW-712137915/ZsKCCJeq8fIcELu5ydMC",
    [MARKETING_EVENTS.stripeVerified]: "AW-712137915/2KZhCMLK_PIcELu5ydMC",
  };
